import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import { ArrowLeft, Calendar } from 'lucide-react';
import { API } from '../api';
import Header from '../components/Header';
import Footer from '../components/Footer';

const StaticPageView = () => {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setNotFound(false);
    setPage(null);
    axios.get(`${API}/pages/${slug}`)
      .then((res) => setPage(res.data))
      .catch(() => setNotFound(true));
  }, [slug]);

  useEffect(() => {
    if (!page) return;
    const title = page.seo_title || page.title || 'Travelsera';
    const desc = page.seo_description || (page.body || '').substring(0, 160);
    document.title = `${title} | Travelsera`;
    let m = document.querySelector('meta[name="description"]');
    if (!m) { m = document.createElement('meta'); m.setAttribute('name', 'description'); document.head.appendChild(m); }
    m.setAttribute('content', desc);
    return () => { document.title = 'Travelsera - Journeys, Redefined'; };
  }, [page]);

  return (
    <div className="min-h-screen bg-white">
      <div className="relative bg-[#0d64a8]">
        <Header />
        <div className="max-w-[1000px] mx-auto px-5 lg:px-8 pt-24 pb-14 text-white">
          <Link to="/" className="inline-flex items-center gap-1.5 text-white/85 hover:text-white text-sm mb-3">
            <ArrowLeft size={15} /> Back to home
          </Link>
          <h1 className="text-3xl md:text-4xl font-bold">{page?.title || (notFound ? 'Page not found' : 'Loading...')}</h1>
          {page?.updated_at && (
            <p className="text-white/70 text-xs mt-2 flex items-center gap-1">
              <Calendar size={11} /> Last updated {new Date(page.updated_at).toLocaleDateString('en-IN', { day: '2-digit', month: 'long', year: 'numeric' })}
            </p>
          )}
        </div>
      </div>

      <article className="py-14">
        <div className="max-w-[820px] mx-auto px-5 lg:px-8">
          {notFound && (
            <div className="py-16 text-center">
              <p className="text-gray-600">This page has not been created yet.</p>
              <Link to="/" className="inline-block mt-4 bg-[#0d64a8] text-white text-sm px-5 py-2 rounded-md">Back to home</Link>
            </div>
          )}
          {page && (
            <div className="prose prose-lg max-w-none text-gray-800">
              {page.body.split(/\n{2,}/).map((para, i) => (
                <p key={i} className="mb-4 leading-relaxed text-[16.5px]">{para}</p>
              ))}
            </div>
          )}
        </div>
      </article>

      <Footer />
    </div>
  );
};

export default StaticPageView;
